export class GetAllPortalDraws {
  static readonly type = '[PortalDraw] Get All Draws';
}

export class GetActivatedPortalDraws {
  static readonly type = '[PortalDraw] Get Activated Draws';
}

export class InitializePortalDraw {
  static readonly type = '[PortalDraw] Initialize Draw';
  constructor(public payload: { examId: string; quantityOfApplications: number }) {}
}

export class InitializeManualPortalDraw {
  static readonly type = '[PortalDraw] Initialize Manual Draw';
  constructor(public payload: { examId: string; applicationIds: string[] }) {}
}

export class UpdatePortalDraw {
  static readonly type = '[PortalDraw] Update Draw';
  constructor(public payload: { id: string; examId: string; quantityOfApplications: number }) {}
}

export class GetSinglePortalDrawByExamId {
  static readonly type = '[PortalDraw] Get Single Draw By Exam Id';
  constructor(public payload: string) {}
}

export class GetSinglePortalDrawById {
  static readonly type = '[PortalDraw] Get Single Draw By Id';
  constructor(public payload: string) {}
}

export class DeletePortalDrawById {
  static readonly type = '[PortalDraw] Delete Draw By Id';
  constructor(public payload: string) {}
}

export class SetSelectedDraw {
  static readonly type = '[PortalDraw] Set Selected Draw';
  constructor(public payload: any) {}
}

/** Load the pool of submitted applications belonging to no draw, first-come-first-served.
 *  Charge le bassin des candidatures soumises sans tirage (premier arrivé, premier servi). */
export class GetUndrawnApplications {
  static readonly type = '[PortalDraw] Get Undrawn Applications';
  constructor(public payload: { examId: string; page?: number; limit?: number; search?: string; previouslyDrawn?: boolean }) {}
}

export class GetArchivedPortalDraws {
  static readonly type = '[PortalDraw] Get Archived Draws';
}

export class UnarchivePortalDrawById {
  static readonly type = '[PortalDraw] Unarchive Draw By Id';
  constructor(public payload: string) {}
}
